<template>
  <div :id="uuid" :style="{ width: width + 'px', height: height + 'px' }" />
</template>

<script setup>
import { getDataJson, pollingRefresh, hasNonEmptyValues, hasProperty } from "@/utils/refresh-cpt-data";
import { onMounted, watch, computed} from "vue";
import * as echarts from 'echarts'

const props = defineProps({
  width: Number,
  height: Number,
  option: Object,
  show: Boolean,
  components: Array,
  current: Object
})
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow,(val)=>{
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(() => props.option.attribute.hideCompInTabw,(val)=>{
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
watch(() => props.option.attribute, (obj) => {
  processData(props.option.cptDataForm, newData, jsFunFlag)
  loadChart(obj);
}, { deep: true })
watch(() => [props.width, props.height], () => {
  chart.resize()
})

let uuid = require('uuid').v1();
let chartOption = {};
let chart = null
let cptData = [];
let newData = "";
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])

onMounted(() => {
  const element = document.getElementById(uuid)
  
  if (!element) return

  chart = echarts.init(element)
  if (dataReload.value.includes(0)) {
    refreshCptData();
  }
})

function refreshCptData(cptDataForm = props.option.cptDataForm, paras) {
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm, paras),
    props.components)
}
function loadData(cptDataForm, paras) {
  cptData = [];
  getDataJson(cptDataForm, paras, (res) => {
    console.log(res, 'res')
    newData = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
    jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
    processData(cptDataForm, newData, jsFunFlag)
    //   res.forEach(item => {
    //     let temp = []
    //     for (let i = 0; i < props.option.attribute.radar.indicator.length; i++) {
    //       const ind = props.option.attribute.radar.indicator[i]
    //       temp[i] = item.data[ind.key]
    //     }
    //     cptData.push({
    //       name: item.group, value: temp,
    //     })
    //   })
    loadChart(props.option.attribute);

  })
}
function processData(cptDataForm, res, jsFunFlag) {
  console.log(res, 'res')
  // 第一层判断 如果选择数据集
  if (cptDataForm.dataSource == '4') {
    // 第二层判断 ，如果没有配转换脚本
    if (jsFunFlag) { // 没有全部配置映射字段
      if (hasNonEmptyValues(props.option.attribute.cptTableData)) {
        const dataKey = props.option.attribute.cptTableData;
        const lxKey = dataKey.find(item => item.namekey === 'group').value;
        const nameKey = dataKey.find(item => item.namekey === 'name').value;
        const valueKey = dataKey.find(item => item.namekey === 'value').value;

        // Create an empty object to store grouped results
        let groups = {};

        // Iterate through the original data
        res.forEach(item => {
          const group = item[nameKey];
          const lx = item[lxKey];
          const value = item[valueKey];

          if (!groups[group]) {
            groups[group] = { data: {} };
          }

          groups[group].data[lx] = value;
        });

        // Transform grouped results into the desired newarr format
        let newarr = Object.entries(groups).map(([group, groupData]) => ({
          group,
          data: groupData.data
        }));
        console.log(newarr, 'newarr')
        newarr.forEach(item => {
          let temp = []
          for (let i = 0; i < props.option.attribute.radar.indicator.length; i++) {
            const ind = props.option.attribute.radar.indicator[i]
            temp[i] = item.data[ind.key]
          }
          cptData.push({
            name: item.group, value: temp,
          })
        })
      }
    } else { // 如果配置了转换脚本
      // cptData = res;
      res.forEach(item => {
        let temp = []
        for (let i = 0; i < props.option.attribute.radar.indicator.length; i++) {
          const ind = props.option.attribute.radar.indicator[i]
          temp[i] = item.data[ind.key]
        }
        cptData.push({
          name: item.group, value: temp,
        })
      })
    }
  } else { // 不是数据集类型，是静态数据
    //  cptData = res;
    res.forEach(item => {
      let temp = []
      for (let i = 0; i < props.option.attribute.radar.indicator.length; i++) {
        const ind = props.option.attribute.radar.indicator[i]
        temp[i] = item.data[ind.key]
      }
      cptData.push({
        name: item.group, value: temp,
      })
    })
  }
}
function transformArray(originalArray, cptTableData) {
  const result = {};

  originalArray.forEach(item => {
    const groupValue = item[cptTableData.find(d => d.namekey === 'group').value];
    const nameValue = item[cptTableData.find(d => d.namekey === 'name').value];
    const valueValue = parseInt(item[cptTableData.find(d => d.namekey === 'value').value], 10);

    if (!result[groupValue]) {
      result[groupValue] = { data: {} };
    }

    result[groupValue].data[nameValue] = valueValue;
  });

  return Object.entries(result).map(([group, obj]) => ({ group, ...obj }));
}
function loadChart(attr) {
  chartOption = {
    color: attr.colors,//配色方案
    legend: attr.legend,
    title: attr.title,
    tooltip: {
      trigger: 'axis',
      ...attr.tooltip,
      // valueFormatter: value => {
      //   console.log(value)  
      //   return value
      // },
      // formatter: (params,ticket) => {
      //   console.log(params,ticket, params.dataIndex, 'aodjiasjijixijczxc')
      //   return 'd'
      // } 
    },
    radar: attr.radar,
    series: [
      {
        type: 'radar',
        tooltip: {
          trigger: 'item'
        },
        lineStyle: {
          width: 3,
        },
        areaStyle: {
          normal: {
            opacity: attr?.areaStyleNormalOpacity || 0.4
          }
        },
        data: cptData
      }
    ]
  }
  chart.setOption(chartOption, true);
  chart.on('click', (params) => {
    emit("clickHandler", props.option.interaction, 'default', params.name)
  })
}

defineExpose({ refreshCptData })
</script>

<style scoped></style>
